import React from 'react';
import PropTypes from 'prop-types';

const Badge = ({ text, color, showText }) => (
  <span>
    <span className={`bg-${color} inline-block w-3 h-3 rounded-full mr-2`} />
    {showText && text}
  </span>
);

export const referralStatuses = {
  draft: ({ showText }) => <Badge text="Draft" color="medium-grey" showText={showText} />,
  sent: ({ showText }) => <Badge text="Needs Action" color="yellow" showText={showText} />,
  in_review: ({ showText }) => <Badge text="In Review" color="orange" showText={showText} />,
  accepted: ({ showText }) => <Badge text="Accepted" color="dark-green" showText={showText} />,
  declined: ({ showText }) => <Badge text="Rejected" color="red" showText={showText} />,
  recalled: ({ showText }) => <Badge text="Recalled" color="orange" showText={showText} />,
  closed: ({ showText }) => <Badge text="Closed" color="blue-700" showText={showText} />,
  off_platform: ({ showText }) => (
    <Badge
      text={'Off Platform'}
      color="blue-700"
      showText={showText}
    />
  ),
  auto_recalled: ({ showText }) => <Badge text="Auto Recalled" color="yellow" showText={showText} />,
  forwarded: ({ showText }) => <Badge text="Forwarded" color="purple" showText={showText} />,
  pending_authorization: ({ showText }) => <Badge text="Needs Action" color="yellow" showText={showText} />,
  denied_authorization: ({ showText }) => <Badge text="Denied Authorization" color="orange" showText={showText} />,
  reviewed: ({ showText }) => <Badge text="Reviewed" color="blue-700" showText={showText} />,
  pending: ({ showText }) => <Badge text="Needs Action" color="yellow" showText={showText} />,
  open: ({ showText }) => <Badge text="Open" color="dark-green" showText={showText} />,
  processed: ({ showText }) => <Badge text="Processed" color="medium-grey" showText={showText} />,
};

Badge.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string.isRequired,
  showText: PropTypes.bool,
};

Badge.defaultProps = {
  text: '',
  showText: true,
};

export const referralStatusNames = {
  draft: () => 'Draft',
  sent: () => 'Needs Action',
  in_review: () => 'In Review',
  accepted: () => 'Accepted',
  declined: () => 'Declined',
  recalled: () => 'Recalled',
  closed: () => 'Closed',
  off_platform: () => 'Off Platform',
  auto_recalled: () => 'Auto Recalled',
  forwarded: () => 'Forwarded',
  pending_authorization: () => 'Needs Action',
  denied_authorization: () => 'Denied Authorization',
  reviewed: () => 'Reviewed',
  pending: () => 'Needs Action',
  open: () => 'Open',
  processed: () => 'Processed',
};
